//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import moment from 'moment';

export default {
	props: ['type', 'person'],
	data: function data() {
		return {
			users: [],
			units: [],
			showing: {
				date: moment().format('MM/DD/YYYY'),
				notes: '',
				type: this.type,
				person: this.person
			},
			errorText: null
		};
	},

	methods: {
		close: function close() {
			Event.$emit('close-small-modal', 'add-showing');
		},
		process: function process() {
			var _this = this;

			var self = this;

			this.errorText = null;

			var sendData = {
				date: this.showing.date,
				user_id: this.showing.user ? this.showing.user.value : null,
				unit_id: this.showing.unit ? this.showing.unit.value : null,
				reporter_type: this.type,
				reporter_id: this.person.id,
				notes: this.showing.notes
			};

			axios.post('/prototype/showings', sendData).then(function (response) {
				if (response.data.error) {
					self.errorText = response.data.error;
					return false;
				}

				_this.$snotify.success('The showing was added.');
				Event.$emit('refresh-guest-card');
				Event.$emit('close-small-modal', 'add-showing');
			});
		},
		getUsers: function getUsers() {
			var self = this;

			window.axios.get('/prototype/user-api/list').then(function (response) {
				self.users = response.data.users.map(function (u) {
					return {
						label: u.full_name,
						value: u.id
					};
				});
			});
		},
		getAvailableUnits: function getAvailableUnits() {

			var self = this;

			window.axios.get('/prototype/properties/available-units').then(function (response) {

				self.units = response.data.map(function (u) {

					return {
						label: u.name,
						value: u.id,
						rent: u.market_rent_amount && parseFloat(u.market_rent_amount) > 0 ? u.market_rent_amount : u.rent_amount
					};
				});
			});
		}
	},
	mounted: function mounted() {
		var _this2 = this;

		var self = this;
		Event.$on('add-showing-guest-card', function () {
			_this2.getUsers();
			_this2.getAvailableUnits();
		});
	},
	beforeDestroy: function beforeDestroy() {
		Event.$off('add-showing-guest-card');
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/AddShowing.vue
// module id = ofzt
// module chunks = 0 1